import { useState, useCallback, useEffect } from "react";
import { api } from "../utils/api";

// ─── Auth Hook ────────────────────────────────────────────────────────────────
export const useAuth = () => {
  const [token, setToken] = useState(() => sessionStorage.getItem("bb_admin_token"));
  const [user, setUser] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem("bb_admin_user")); }
    catch { return null; }
  });

  const login = (t, u) => {
    setToken(t); setUser(u);
    sessionStorage.setItem("bb_admin_token", t);
    sessionStorage.setItem("bb_admin_user", JSON.stringify(u));
  };

  const logout = () => {
    setToken(null); setUser(null);
    sessionStorage.removeItem("bb_admin_token");
    sessionStorage.removeItem("bb_admin_user");
  };

  return { token, user, login, logout, isAuthenticated: !!token && !!user };
};

// ─── Toast Hook ───────────────────────────────────────────────────────────────
export const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const show = useCallback((msg, type = "success") => {
    const id = Date.now();
    setToasts(t => [...t, { id, msg, type }]);
    setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), 4000);
  }, []);

  const remove = useCallback((id) => setToasts(t => t.filter(x => x.id !== id)), []);

  return { toasts, show, remove };
};

// ─── API Fetch Hook ───────────────────────────────────────────────────────────
export const useFetch = (path, token, deps = []) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    if (!path) return;
    setLoading(true); setError(null);
    try {
      const res = await api(path, { method: "GET" }, token);
      setData(res.data ?? res);
    } catch (e) {
      setError(e.message);
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [path, token]); // eslint-disable-line

  useEffect(() => { refetch(); }, [refetch]);

  return { data, loading, error, refetch };
};

// ─── Modal Hook ───────────────────────────────────────────────────────────────
export const useModal = () => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);

  const openWith = (d = null) => { setData(d); setOpen(true); };
  const close = () => { setOpen(false); setData(null); };

  return { open, data, openWith, close };
};
